import ReactDOM from 'react-dom/client';

import App from './App';

import './index.css';

// Add Buffer polyfill
import { Buffer } from 'buffer';

globalThis.Buffer = Buffer;

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <App />,
);
